import { icons } from "lucide-react";
import { cn } from "~/lib/utils.ts";

import { ErrorProps, FormError } from ".";
import { Input } from "../ui";

// interface FormInputProps {
//   autoFocus?: boolean;
//   readOnly?: boolean;
//   label?: string;
//   type?: string;
//   placeholder?: string;
//   required?: boolean;
//   errors?: ErrorProps;
//   register: any;
//   labelExtra?: React.ReactNode;
//   description?: React.ReactNode;
//   suffix?: keyof typeof icons;
//   suffixClass?: string;
//   onSuffixClick?: () => void;
//   className?: string;
//   value?: string;
//   step?: string;
// }
interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  autoFocus?: boolean;
  readOnly?: boolean;
  label?: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  errors?: ErrorProps;
  register: any;
  labelExtra?: React.ReactNode;
  description?: React.ReactNode;
  suffix?: keyof typeof icons;
  prefix?: keyof typeof icons;
  suffixClass?: string;
  onSuffixClick?: () => void;
  className?: string;
  suffixText?: string;
}
export default function FormTextInput({
  id,
  autoComplete,
  label,
  required,
  errors,
  autoFocus,
  register,
  labelExtra,
  readOnly,
  placeholder,
  suffix,
  suffixClass,
  type,
  description,
  className,
  onSuffixClick,
  value,
  ...rest
}: FormInputProps) {
  return (
    <div className="space-y-1">
      {label && (
        <label htmlFor={id} className="flex gap-2 mb-1">
          <div
            className={cn("font-Medium text-sm", {
              "text-danger-500": errors?.error,
            })}
          >
            {label} {required && <span className="text-danger-400">*</span>}
          </div>
          {labelExtra}
        </label>
      )}
      <Input
        id={id}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        readOnly={readOnly}
        type={type ? type : "text"}
        placeholder={placeholder}
        suffix={suffix}
        suffixClass={suffixClass}
        className={cn(className, {
          "border-danger-500": errors?.error,
        })}
        onSuffixClick={onSuffixClick}
        {...rest}
        // {...register?.inputRegister(register?.name, {
        //   valueAsNumber: type === InputTypes.NUMBER,
        // })}
        value={value}
        {...register}
      />
      {description && <div>{description}</div>}
      <FormError error={errors?.error} message={errors?.message} />
    </div>
  );
}
